import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_NAME = "PSHL8 — Pro Skate Hockey League";
const DEFAULT_DESCRIPTION =
  "India's professional skate hockey franchise league. Sponsorships, franchises, academies, draft, media — built sponsor-first, broadcast-ready.";
const FRONTEND_ORIGIN =
  (typeof window !== "undefined" && window.location?.origin) || "";

/**
 * Per-page meta tag helper.
 *
 * NOTE: react-helmet-async runs on the client. For social-media crawlers that
 * do NOT execute JavaScript (Facebook, LinkedIn, WhatsApp, X), the static
 * `index.html` defaults still apply unless this site is migrated to SSR
 * (Next.js etc) or fronted by a meta-tag proxy. Documented in PRD.md.
 */
export default function PageMeta({
  title,
  description = DEFAULT_DESCRIPTION,
  image,
  imageAlt,
  url,
  type = "website",
}) {
  const fullTitle = title ? `${title} · PSHL8` : SITE_NAME;
  // Resolve image to an absolute URL when given a relative path
  const absoluteImage = image
    ? image.startsWith("http")
      ? image
      : `${FRONTEND_ORIGIN}${image}`
    : `${FRONTEND_ORIGIN}/og-image.png`;
  const absoluteUrl = url
    ? url.startsWith("http")
      ? url
      : `${FRONTEND_ORIGIN}${url}`
    : (typeof window !== "undefined" ? window.location.href : FRONTEND_ORIGIN);

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={absoluteUrl} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={absoluteUrl} />
      <meta property="og:image" content={absoluteImage} />
      <meta property="og:image:alt" content={imageAlt || fullTitle} />

      {/* Twitter / X */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={absoluteImage} />
      <meta name="twitter:image:alt" content={imageAlt || fullTitle} />
    </Helmet>
  );
}
